import Vue from 'vue'
import Vuex from 'vuex'
import loadingStore from './loading'
import userStore from './user'
import notificationStore from './notification'
import contactStore from './contact'
import companyStore from './company'
import userCompanyStore from './userCompany'
import userSoleProprietorshipStore from './userSoleProprietorship'
import companyCompetitionStore from './companyCompetition'
import imageStore from './image'
import newsStore from './news'
import certificationStore from './certification'
import competitionStore from './competition'
import soleProprietorshipStore from './soleProprietorship'
import fundMapStore from './fundMap'
import createFundStore from './createFund'
import categoryCacheStore from './categoryCache'

Vue.use(Vuex)

const rootStore = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    userStore,
    loadingStore,
    notificationStore,
    contactStore,
    companyStore,
    soleProprietorshipStore,
    userCompanyStore,
    userSoleProprietorshipStore,
    companyCompetitionStore,
    competitionStore,
    imageStore,
    newsStore,
    certificationStore,
    fundMapStore,
    createFundStore,
    categoryCacheStore
  }
})

export default rootStore
